import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../modal/modal.component';
import { ActivatedRoute } from '@angular/router';
import CustomEncoder from '../../../core/helpers/customer-encoder';

// tslint:disable-next-line: no-empty-interface
export interface DialogData { }

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

export class SidebarComponent implements OnInit, OnChanges {
  @Input() company;
  @Input() mobile;
  @Input() vacancyPosition;
  @Input() modal: Boolean;

  @Output() CloseModal = new EventEmitter<Boolean>();

  position: any;

  // tslint:disable-next-line: max-line-length
  public quemindica = false;
  public userReferal = this.route.snapshot.queryParams.user_referral;

  private customerEncoderHelper = new CustomEncoder();

  constructor(
    private dialog: MatDialog,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {

    if (this.route.snapshot.url.length) {
      this.quemindica = this.route.snapshot.url[0].path === 'exclusivos' || this.route.snapshot.url[0].path === 'mobile-dream-indicacao' || this.route.snapshot.url[0].path === 'quem-indica';
    }

    this.route.queryParams
      .subscribe(queryParams => {
        if (queryParams.user_referral) {
          this.userReferal = queryParams.user_referral;
        }
      }, (err) => { });
  }

  ngOnChanges(): void { }

  formatUrls(url: string): string {
    return this.customerEncoderHelper.formatUrls(url);
  }

  scrollWindow(key): void {
    for (const i of this.vacancyPosition) {
      if (i.key === key) {
        this.position = i;
      }
    }

    this.position.scroll.nativeElement.scrollIntoView({
      behavior: 'smooth'
    });
  }

  openDialog(): void {
    if (!this.company) {
      return;
    }

    if (this.company.canCreatePrivateVacancies && this.company.hiddenLandingPage && !this.company.hiddenLandingPage.indication) {
      return;
    }

    this.CloseModal.emit();
    this.dialog.open(ModalComponent, {
      width: '400px',
      data: {
        company: this.company,
        url_path: this.route.snapshot.url[0].path
      }
    });
  }
}
